import convertPercents from "./converters/convert-percents";
import convertUnits from "./converters/convert-units";
import convertDates from "./converters/convert-dates";

function convertAll(obj, prefered) {
  convertPercents.call(this, obj, prefered);
  convertDates.call(this, obj, prefered);
  convertUnits.call(this, obj, prefered);
  return obj;
}

export default convertAll;
